<template>
  <header
    slot="content-header"
    class="navbar navbar-header navbar-header-fixed"
  >
    <div
      @click="closeLevel2()"
      class="container d-flex flex-row align-items-center justify-content-center"
    >
      <a @click.stop="showLevel2()" class="burger-menu d-lg-none">
        <feather type="menu" class="wd-30-f ht-30-f"></feather>
      </a>
      <div class="mg-l-10 d-none d-md-block d-sm-block  tx-color-02">
        {{ course.name }}
        <div class="progress ht-15">
          <div
            class="progress-bar wd-25p"
            :style="`width: ${course.percent}%`"
            role="progressbar"
          >
            {{ course.percent }}%
          </div>
        </div>
      </div>
      <div class="navbar-right">
        <a
          @click.stop="closeLevel2()"
          class="burger-menu d-lg-none"
          v-if="$store.state.app.responsiveLayout.level2.show"
        >
          <feather type="arrow-right" class="wd-30-f ht-30-f"></feather>
        </a>
        <a @click.stop="$emit('toggle-team-chat')" class="burger-menu">
          <feather type="message-square" class="wd-30-f ht-30-f"></feather>
        </a>
        <router-link
          class="burger-menu"
          :to="
            $route.params.iid > 0
              ? {
                  name: 'lmsCourseView',
                  params: { id: $route.params.id, bid: 0, iid: 0, bot: 0 }
                }
              : {
                  name: 'lmsCourses',
                  params: {
                    md: courseMode.mode,
                    cnm: 'null',
                    type: -1,
                    d1: 'null',
                    d2: 'null'
                  }
                }
          "
        >
          <feather type="x" class="wd-30-f ht-30-f"></feather>
        </router-link>
      </div>
    </div>
  </header>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    navbarmode: {
      type: Number,
      default: () => 0
    },
    course: {
      type: Object,
      default: () => {}
    },
    courseMode: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    ...mapActions([
      "resetResponsiveLayoutConfig",
      "handleLevel2ResponsiveLayoutConfig"
    ]),
    showLevel2() {
      this.handleLevel2ResponsiveLayoutConfig({
        document: document,
        className: "course-sidebar-show"
      });
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    }
  }
};
</script>

<style></style>
